export enum EventTemplateType {
  Registartion = 1,
  Event = 2
}